import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroBanner } from './components/HeroBanner';
import { BookOnline } from './components/BookOnline';
import { OurServices } from './components/OurServices';
import { HousekeepingRevolution } from './components/HousekeepingRevolution';
import { FAQ } from './components/FAQ';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { FAQPage } from './pages/FAQPage';
import { AboutUs } from './pages/AboutUs';
import { ContactUs } from './pages/ContactUs';
import { BasicHomeCleaning } from './pages/BasicHomeCleaning';
import { SEOHead } from './components/SEOHead';
import { OrganizationSchema, WebsiteSchema } from './components/StructuredData';
function HomePage() {
  return <div className="min-h-screen w-full font-sans bg-white" data-id="element-0">
      <SEOHead title="Smith & Jengs Cleaning Services | Professional Cleaning in Bicester & Oxfordshire" description="Professional residential and commercial cleaning services in Bicester and Oxfordshire. Eco-friendly products, vetted cleaners, online booking, and 100% satisfaction guarantee." canonical="https://smithandjengs.com/" data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroBanner data-id="element-3" />
      <BookOnline data-id="element-4" />
      <OurServices data-id="element-5" />
      <HousekeepingRevolution data-id="element-6" />
      <FAQ data-id="element-7" />
      <WhyChooseUs data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <Router data-id="element-10">
      <div className="relative" data-id="element-11">
        <OrganizationSchema data-id="element-12" />
        <WebsiteSchema data-id="element-13" />
        <Routes data-id="element-14">
          <Route path="/" element={<HomePage data-id="element-16" />} data-id="element-15" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-18" />} data-id="element-17" />
          <Route path="/faq" element={<FAQPage data-id="element-20" />} data-id="element-19" />
          <Route path="/about-us" element={<AboutUs data-id="element-22" />} data-id="element-21" />
          <Route path="/contact-us" element={<ContactUs data-id="element-24" />} data-id="element-23" />
          <Route path="/basic-home-cleaning" element={<BasicHomeCleaning data-id="element-26" />} data-id="element-25" />
        </Routes>
        <CookieConsent data-id="element-27" />
      </div>
    </Router>;
}